import Page from '@/Models/Page';
import { ProfileCriteriaScoreResponse } from './ProfileCriteriaScoreResponse';
import { ProfileMatchScoreResponse } from './ProfileMatchScoreResponse';
import { ProfileResponse } from './ProfileResponse';

/**
 * Identified profile response
 */
export interface IdentifiedProfileResponse {
    /**
     * Unique identifier for the profile
     */
    id: string;

    /**
     * Reference to the original profile Id.
     */
    profileId: string;

    /**
     * Unique identifier for the recruitment associated with this profile.
     */
    recruitmentId: string;

    /**
     * Profile data containing all LinkedIn profile information.
     */
    profile: ProfileResponse;

    /**
     * Collection of criteria scores for this profile.
     */
    searchCriteriaScores: ProfileCriteriaScoreResponse[] | null;

    /**
     * An averaged score from every search criteria scores available.
     */
    matchScore: ProfileMatchScoreResponse | null;
}

export const DefaultIdentifiedProfileResponse: Page<IdentifiedProfileResponse> = {
    data: [],
    pagination: {
        offset: 0,
        limit: 0,
        totalCount: 0,
    },
};
